import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes: [
		{path: '/',component:()=>import("./pages/index.vue"),name:"首页"},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"首页"},
		{path: '/login',component:()=>import("./pages/login.vue"),name:"登录",},
		{path: '/reg',component:()=>import("./pages/register.vue"),name:"注册"},
		{path: '/regUpdate',component:()=>import("./pages/register-update.vue"),name:"修改信息"},
		{path: '/reset-pwd',component:()=>import("./pages/reset-pwd.vue"),name:"重置密码"},
		{path: '/list',component:()=>import("./pages/list.vue"),name:"列表"},
		{path: '/cart',component:()=>import("./pages/cart.vue"),name:"购物车"},
		{path: '/coupons',component:()=>import("./pages/coupons.vue"),name:"我的优惠券",meta:{secondaryOnly:true}},
		{path: '/orders',component:()=>import("./pages/orders.vue"),name:"我的订单",meta:{secondaryOnly:true}},
		{path: '/orderDetail',component:()=>import("./pages/order-detail.vue"),name:"订单详情"},
		{path: '/score',component:()=>import("./pages/score.vue"),name:"积分商城",meta:{integralOnly:true}},
		{path: '/scoreDetails',component:()=>import("./pages/score-details.vue"),name:"积分商品详情",meta:{integralOnly:true}},
		{path: '/integralRecord',component:()=>import("./pages/integral-record.vue"),name:"积分明细",meta:{integralOnly:true}},
		{path: '/integralSubmit',component:()=>import("./pages/integral-submit.vue"),name:"积分兑换",meta:{integralOnly:true}},
		{path: '/integralOrders',component:()=>import("./pages/integralOrders.vue"),name:"积分订单",meta:{integralOnly:true}},
		{path: '/integralOrderDetail',component:()=>import("./pages/integral-order-detail.vue"),name:"积分订单详情",meta:{integralOnly:true}},
		{path: '/regProgress',component:()=>import("./pages/regProgress.vue"),name:"注册审核进度"},
		{path: '/address',component:()=>import("./pages/address.vue"),name:"收货地址",meta:{addressOnly:true}},
		{path: '/baseInfo',component:()=>import("./pages/baseInfo.vue"),name:"账户信息"},
		{path: '/details',component:()=>import("./pages/details.vue"),name:"详情页"},
		{path: '/tobuy',component:()=>import("./pages/tobuy.vue"),name:"去结算",meta:{secondaryOnly:true}},
		{path: '/kefu',component:()=>import("./pages/kefu.vue"),name:"添加客服"},
		{path: '/batch-search',component:()=>import("./pages/batch-search.vue"),name:"批量搜索"},
		{path: '/selection',component:()=>import("./pages/selection.vue"),name:"产品选型"}
	]
})
